// Which record's Verlauf column is on screen, as the API path segment its
// nested routes are mounted under.
//
// The column and its note form are the same markup for every entity that has a
// timeline, so the templates say which one by putting a single
// `data-<entity>-id` on the scroll container and on the form. This turns that
// into the path both modules fetch from, rather than each of them assuming a
// customer.
//
// Keep this table in step with NESTED_PARAMS in
// controllers/helpers/entitaetScope.js: an entity in one and not the other is
// either unfetchable or unresolvable.
const PARENTS = [
  // Ahead of the plain customer entry, and the reason the list is ordered
  // rather than a map: a contact's column carries *both* ids - the entries it
  // shows are the customer's - and the more specific path has to win, or
  // "load more" would append the customer's unfiltered timeline underneath a
  // filtered first page.
  {
    attribut: 'ansprechpersonId',
    pfad: (dataset) => `kunden/${dataset.kundeId}/ansprechpersonen/${dataset.ansprechpersonId}`
  },
  { attribut: 'kundeId', pfad: 'kunden' },
  { attribut: 'jobId', pfad: 'jobs' },
  { attribut: 'kandidatId', pfad: 'kandidaten' },
  { attribut: 'leadId', pfad: 'leads' }
  // No `konzernId`: the Konzern page carries no Verlauf column, so nothing ever
  // sets that attribute. The nested API route exists and the events are written
  // - adding the entry here is all this file would need if a column is wanted.
];

// Returns e.g. 'kandidaten/6aa7…', or null when the element names no parent
// this knows - a template mistake rather than something to guess at.
export function verlaufParentPfad(dataset) {
  const treffer = PARENTS.find((entry) => dataset[entry.attribut]);
  if (!treffer) return null;

  // A string pfad is the ordinary '<resource>/<id>' case; a function is for the
  // nested one, which needs more than its own id to build a path.
  return typeof treffer.pfad === 'function'
    ? treffer.pfad(dataset)
    : `${treffer.pfad}/${dataset[treffer.attribut]}`;
}
